import React, { useEffect, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Pagination, PaginationItem } from '@mui/material';
import { CouponsContext } from '../../context/CouponsContext';

const CouponsPagination = ({ totalPages, onPageChange, couponProp, scrollId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { coupons: couponsContext } = useContext(CouponsContext);
  // O contexto pode guardar o array de cupons ou a resposta paginada ({ data, ... })
  const contextList = Array.isArray(couponsContext) ? couponsContext : couponsContext?.data;
  const coupons = couponProp ?? contextList ?? [];

  const queryParams = new URLSearchParams(location.search);
  const currentPage = parseInt(queryParams.get("page")) || 1;

  // 🎯 controla se deve scrollar (apenas quando usuário clicar)
  const shouldScrollRef = useRef(false);

  const handlePageChange = (event, page) => {
    shouldScrollRef.current = true; // 👈 marca que foi ação do usuário

    queryParams.set("page", page);
    navigate({ search: queryParams.toString() });

    if (onPageChange) onPageChange();
  };

  // 🔁 Reset para página 1 se não houver dados
  useEffect(() => {
    if (coupons.length === 0 && currentPage !== 1) {
      queryParams.set("page", 1);
      navigate({ search: queryParams.toString() }, { replace: true });
    }
  }, [coupons, currentPage, navigate, location]);

  // 🎯 Scroll automático SOMENTE quando usuário clicar
  useEffect(() => {
    if (!scrollId || !shouldScrollRef.current) return;

    const element = document.getElementById(scrollId);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    shouldScrollRef.current = false; // reseta a flag
  }, [currentPage, scrollId]);

  return (
    <Pagination
      count={totalPages}
      page={currentPage}
      onChange={handlePageChange}
      color="primary"
      sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 3 }}
      renderItem={(item) => (
        <PaginationItem {...item} component="button" />
      )}
    />
  );
};

export default CouponsPagination;